import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { AppStateService } from '../services/app-state.service';

@Injectable({ providedIn: 'root' })
export class RedirectToNewAppGuard implements CanActivate {
  constructor(private readonly appStateService: AppStateService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // Replace this with your actual redirect logic
    if (this.isRedirectUrlToNewApp(state.url)) {
      window.location.href = state.url;
      return false;
    }
    return true;
  }

  private isRedirectUrlToNewApp(url: string): boolean {
    return this.appStateService
      .getRedirectUrlsToNewApp()
      .some((redirectUrl) => url.includes(redirectUrl));
  }
}
